import React, {useState} from 'react';

import {TableRow} from "@mui/material";

function StyledTableRow(props) {
    const [hovered, setHovered] = useState(false);

    return (
        <TableRow
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            sx={{
                backgroundColor: hovered ? "#fafafa" : "#ffffff",
                ...props.sx
            }}
            {...props}
        >
            {props.children}
        </TableRow>
    );
}

export default StyledTableRow;
